var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowTopLight = function SvgIconArrowTopLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_arrow_top_light_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_arrow_top_light_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.122 19.722a2.368 2.368 0 0 1 3.377.022l7.1 7.5L31 28.756l-7.085-7.484a.167.167 0 0 0-.232 0l-7.085 7.484L15 27.244l7.1-7.5a1.07 1.07 0 0 1 .021-.022Z",
    fill: "#121619"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_arrow_top_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_arrow_top_light_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15 19)",
    d: "M0 0h17.6v9.7H0z"
  })))));
};
export default SvgIconArrowTopLight;